import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinimize, faMaximize } from '@fortawesome/pro-regular-svg-icons'
import {  } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from '../architecture/frontend/index'
import _ from 'lodash'
import EntryItem from '../EntryTypes'

const Wizard = (props) => {
  return (
    <div className='w-100 pa4 pv6 flex items-center justify-center' style={{background: '#f5f3f5'}}>
      <div className='pa3 br2 bg-evonik-light-purple white f6 fw6 flex pointer items-center'
        onClick={e => Dispatch.nextState('shipment', {sentShipment: false})}
        >
        <FontAwesomeIcon className='f4 white' icon={faMinimize} />
        <div className='pl2'>Received</div>
      </div>
      <div className='ml3 pa3 br2 bg-evonik-light-purple white f6 fw6 flex pointer items-center'
        onClick={e => Dispatch.nextState('shipment', {sentShipment: true})}
        >
        <FontAwesomeIcon className='f4 white' icon={faMaximize} />
        <div className='pl2'>Shipped</div>
      </div>
    </div>
  )
}

const Shipment = (props) => {
  const view = props.shipment === 'loading' ? 'loading' : !_.isNil(props.shipment) ? 'shipment' : 'wizard'
  const ingredientOptions = _.filter(props.ingredients?.rawData ?? [], ingredient => ingredient?.sampleType?.id === props.shipment?.sampleType && ingredient.isActive)
  return (
    <div>
      {view === 'wizard' && <Wizard {...props}/>}
      {view === 'shipment' && 
        props.shipmentTypes && !props.shipmentTypes.loading &&
        props.ingredients && !props.ingredients.loading &&
        props.locations && !props.locations.loading &&
        <>
         <div className='w-100 pv3 ph4' style={{background: '#f5f3f5'}}>
            {props.shipment.status &&  
              <div className='w-100'>
                <EntryItem _title='Status' _type={'status'} {...props}/>
              </div>
            }

            <div className='pt2 w-100 flex justify-between'>
              {/* Column 1 */}
              <div className='' style={{flexGrow: 2}}>
                <EntryItem _title='Shipment Type' _type={'select'} _updateType={'sampleType'} _value={props.shipmentTypes?.rawData?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? []} {...props}/>
                <EntryItem _title='Ingredient'_type={'select'} _updateType={'ingredient'} _value={ingredientOptions?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } _disabled={props.shipment?.sampleType ? false : true} {...props}/>
                <EntryItem _title='Origin' _type={'select'}  _updateType={'origin'} _value={_.filter(props.locations.rawData, location => location.type==='ORIGIN' && location.isActive)?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } _disabled={props.shipment?.ingredient ? false : true} {...props}/>
                <EntryItem _title='Customer' _type={'select'} _updateType={'customer'} _value={_.filter(props.locations.rawData, location => location.type==='CUSTOMER' && location.isActive)?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } _disabled={props.shipment?.origin ? false : true} {...props}/>
                <EntryItem _title='Remarks' _type={'text'} _updateType={'shipmentRemarks'} _large={true} {...props}/>
              </div>

              {/* Column 2 */}
              <div className='' style={{flexGrow: 1}}>
                <EntryItem _title='Shipment Id' _type={'text'} _updateType={'shipmentId'} {...props}/>
                <EntryItem _title='Ship Date' _type={'date'} _updateType={'shipmentShippedDate'} {...props}/>
                <EntryItem _title='Invoice Number' _type={'text'} _updateType={'shipmentInvoiceNumber'} {...props}/>
                <EntryItem _title='Invoice Amount' _type={'text'} _updateType={'shipmentInvoiceAmount'} {...props}/>
                <EntryItem _title='Tons' _type={'text'} _updateType={'shipmentTons'} {...props}/>
                <EntryItem _title='Custom Identifier' _type={'text'} _updateType={'shipmentCustomId'} {...props}/>
                { props.shipment.duplicates && <div className='dib mt2 pa2 bg-light-yellow f7 fw6 dark-gray'>Possible duplicates: {props.shipment.duplicates}</div>}
              </div>

              {/* Used to align justify-between */}
              <div></div>
            </div>

            {/* <div className='pt3 mt3 w-100 flex justify-between bt b--moon-gray' style={{background: '#f5f3f5'}}>
              <div className='' style={{flexGrow: 2}}>
                <EntryItem _title='Claim Date' _child={entryTypes.date}/>
              </div>
              <div className='' style={{flexGrow: 1}}>
                <EntryItem _title='Customer Identifier' _child={entryTypes.date}/>
              </div>
            </div> */}
          </div>
          </>
          }
       

    </div>
  )
}

export default Shipment